export abstract class IKbRecord {
    /**
     * Maps the name of model classes in KB to
     * host data of KB.
     * @see kb-event-record.ts, kb-document-record.ts (class names)
     */
    type:string;
    id: number;
    title: string;
    subTitle: string;
    text: string;
    searchId:string;
    humanRatings:{
        userVote: string;
        ratingOptions: object,
        score: number
    };
    /**
     * The id of object originally digested
     * from KB engine to then create a Kb record.
     * Used to display the original source object
     * details in its own view/form.
     */
    sourceId:string
    source: object;
}